
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k9TfW", function(module, exports) {
/**
 * @generated SignedSource<<85851f6331fdff74b3338b14e05b8616>>
 * @relayHash e8ab1aa41f56a8e58f4647aa87445304
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44d71eb1075e55c9e8988db704ccfc0b6109617afe7632d2d7fe5937068a9f7a
const $aa2df423f4e2632a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchPresenceAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchPresenceAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e8ab1aa41f56a8e58f4647aa87445304",
            "id": "44d71eb1075e55c9e8988db704ccfc0b6109617afe7632d2d7fe5937068a9f7a",
            "metadata": {},
            "name": "fetchPresenceAGGUsersQuery",
            "operationKind": "query",
            "text": "query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,name,picture,id}}"
        }
    };
}();
$aa2df423f4e2632a$var$node.hash = "57d1e29c802c13d5478283a266661ce1";
var $aa2df423f4e2632a$export$2e2bcd8739ae039 = $aa2df423f4e2632a$var$node;



var $c0rhi = parcelRequire("c0rhi");

const $aed2f5bf61ddaaa1$export$9db34321b84dd37a = (accountIds)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $aa2df423f4e2632a$export$2e2bcd8739ae039),
        variables: {
            accountIds: accountIds
        },
        interopApolloAggClient: true,
        __callerPackage__: "team-presence"
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId || ''
            })) ?? [];
    });
};
module.exports["fetchPresenceAGGUsers"] = $aed2f5bf61ddaaa1$export$9db34321b84dd37a;

});

parcelRegister("iwQHw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $a2bT0 = parcelRequire("a2bT0");


var $ji12t = parcelRequire("ji12t");


var $d6Ahp = parcelRequire("d6Ahp");


var $3EM6l = parcelRequire("3EM6l");


var $9wGTI = parcelRequire("9wGTI");


var $gedcG = parcelRequire("gedcG");


var $gk8Zi = parcelRequire("gk8Zi");

const $82c5dbca758f5691$var$AGENT_AVATAR_CLIP_PATH = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $82c5dbca758f5691$var$AGENT_AVATAR_SHELL_BORDER_WIDTH = 1;
const $82c5dbca758f5691$var$EXTERNAL_AGENT_AVATAR_COLOR = '#DDDEE1';
const $82c5dbca758f5691$var$externalAgentAvatarBackgroundStyles = null;
const $82c5dbca758f5691$var$styles = {
    root: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _1mT5xdRAKS",
    small: "_0jFU0VHVRi _39xV02oWWg",
    medium: "_0jFU0VrIqH _39xV02Uofl",
    overlapped: "_0GTcwRTUhv",
    avatarContent: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _42Yu6B7dHp",
    shell: "_3iDTPbvLZJ _1mT5xdWVPG _3OE6xY715P _42Yu6B7dHp _1pp6NdYbGa",
    legacyBorder: "_1mT5xdRAKS _1llTr68BLF"
};
const $82c5dbca758f5691$var$ExternalAgentAvatar = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { size: size } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbccYA _1uo2ZfTcEg _2yBoao1qiM"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== size) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "external-agent-avatar",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: size
        }));
        $[1] = size;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $82c5dbca758f5691$var$AgentAvatarShell = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { backgroundColor: backgroundColor, borderColor: borderColor, size: size } = t0;
    const { width: width, height: height } = (0, $gk8Zi.AGENT_AVATAR_SHELL_SIZE)[size];
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            top: "0.2px",
            transform: "translateX(-50%) rotate(0deg)",
            opacity: 1
        };
        $[0] = t1;
    } else t1 = $[0];
    const t2 = `0 0 ${width} ${height}`;
    const t3 = (0, $gk8Zi.AGENT_AVATAR_SHELL_PATH)[size];
    let t4;
    if ($[1] !== backgroundColor || $[2] !== borderColor || $[3] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-testid": "agent-presence-avatar-shell-shape",
            d: t3,
            fill: backgroundColor,
            stroke: borderColor,
            strokeWidth: $82c5dbca758f5691$var$AGENT_AVATAR_SHELL_BORDER_WIDTH,
            vectorEffect: "non-scaling-stroke"
        });
        $[1] = backgroundColor;
        $[2] = borderColor;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== height || $[6] !== t2 || $[7] !== t4 || $[8] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.shell,
            style: t1,
            testId: "agent-presence-avatar-shell"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            "data-testid": "agent-presence-avatar-shell-svg",
            display: "block",
            width: width,
            height: height,
            viewBox: t2,
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            focusable: "false"
        }, t4));
        $[5] = height;
        $[6] = t2;
        $[7] = t4;
        $[8] = width;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $82c5dbca758f5691$var$getShellColors = (agent, borderColor)=>{
    switch(true){
        case agent.isExternalAgentFallback:
            return {
                backgroundColor: $82c5dbca758f5691$var$EXTERNAL_AGENT_AVATAR_COLOR,
                borderColor: borderColor ?? $82c5dbca758f5691$var$EXTERNAL_AGENT_AVATAR_COLOR
            };
        default:
            {
                const { primary: primary } = (0, $a2bT0.getAgentAvatarColor)({
                    agentIdentityAccountId: agent.identity_account_id,
                    agentId: agent.id,
                    agentNamedId: agent.external_config_reference ?? agent.named_id
                });
                return {
                    backgroundColor: primary,
                    borderColor: borderColor ?? primary
                };
            }
    }
};
const $82c5dbca758f5691$var$isNormallyWhiteBrand = (agentIcon)=>{
    switch(agentIcon){
        case 'antigravity':
        case 'codex':
        case 'gemini':
        case 'hermes':
        case 'microsoft-copilot':
        case 'vscode':
            return true;
        default:
            return false;
    }
};
function $82c5dbca758f5691$export$1233303c82069087(t0) {
    const $ = (0, $bDgLe.c)(55);
    const { agent: agent, isOverlapped: isOverlapped, stackIndex: stackIndex, showBorder: showBorder, size: t1 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const colorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    let isAgentPresenceMoveEnabled = false;
    if ((0, $9wGTI.fg)("platform_move_presence_agents")) isAgentPresenceMoveEnabled = true;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = isAgentPresenceMoveEnabled && (0, $9wGTI.fg)("confluence_refined_agent_presence_geometries");
        $[0] = t2;
    } else t2 = $[0];
    const isRefinedGeometryEnabled = t2;
    const usesSharedFacepileOutline = isRefinedGeometryEnabled && stackIndex !== undefined;
    let t3;
    if ($[1] !== agent.agentIcon) {
        t3 = $82c5dbca758f5691$var$isNormallyWhiteBrand(agent.agentIcon);
        $[1] = agent.agentIcon;
        $[2] = t3;
    } else t3 = $[2];
    const isWhiteBrand = t3;
    const centerStrokeColor = isRefinedGeometryEnabled && colorMode === "light" && isWhiteBrand ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined;
    let t4;
    if ($[3] !== centerStrokeColor || $[4] !== size || $[5] !== usesSharedFacepileOutline) {
        t4 = isRefinedGeometryEnabled ? {
            width: usesSharedFacepileOutline ? 0 : 2,
            svgHeight: size === "small" ? 27 : 36,
            centerStrokeColor: centerStrokeColor,
            centerStrokeWidth: centerStrokeColor ? 1 : undefined
        } : undefined;
        $[3] = centerStrokeColor;
        $[4] = size;
        $[5] = usesSharedFacepileOutline;
        $[6] = t4;
    } else t4 = $[6];
    const presenceOutline = t4;
    let t5;
    if ($[7] !== agent) {
        t5 = (avatarSize, presenceArtwork)=>agent.agentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
                name: agent.name,
                agentIcon: agent.agentIcon,
                avatarSize: avatarSize,
                hasInlineSpacing: false,
                colorMode: presenceArtwork?.colorMode,
                borderColor: presenceArtwork?.borderColor,
                presenceTileFill: presenceArtwork?.presenceTileFill,
                presenceOutline: presenceArtwork?.presenceOutline,
                usePresenceArtwork: presenceArtwork ? true : undefined
            }) : agent.isExternalAgentFallback ? (0, $9wGTI.fg)("confluence_agent_presence_shared_agent_code") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gedcG.ExternalAgentAvatar), {
                size: avatarSize
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82c5dbca758f5691$var$ExternalAgentAvatar, {
                size: avatarSize
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                key: agent.id,
                imageUrl: agent.avatarUrl,
                agentId: agent.id,
                agentIdentityAccountId: agent.identity_account_id,
                agentNamedId: agent.external_config_reference ?? agent.named_id,
                size: avatarSize,
                showBorder: false,
                isForgeAgent: (0, $ji12t.isForgeAgent)(agent),
                forgeAgentIconUrl: agent.icon
            });
        $[7] = agent;
        $[8] = t5;
    } else t5 = $[8];
    const renderAgentAvatar = t5;
    if (!isAgentPresenceMoveEnabled) {
        const t6 = showBorder && $82c5dbca758f5691$var$styles.legacyBorder;
        let t7;
        if ($[9] !== t6) {
            t7 = (0, $w6R6I.cx)(t6);
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        let t8;
        if ($[11] !== stackIndex) {
            t8 = {
                zIndex: stackIndex
            };
            $[11] = stackIndex;
            $[12] = t8;
        } else t8 = $[12];
        let t9;
        if ($[13] !== renderAgentAvatar) {
            t9 = renderAgentAvatar("medium");
            $[13] = renderAgentAvatar;
            $[14] = t9;
        } else t9 = $[14];
        let t10;
        if ($[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t7,
                style: t8
            }, t9);
            $[15] = t7;
            $[16] = t8;
            $[17] = t9;
            $[18] = t10;
        } else t10 = $[18];
        return t10;
    }
    const avatarSize_0 = size;
    let shellColors;
    let t6;
    if ($[19] !== agent || $[20] !== avatarSize_0 || $[21] !== colorMode || $[22] !== isWhiteBrand || $[23] !== presenceOutline || $[24] !== renderAgentAvatar || $[25] !== showBorder || $[26] !== usesSharedFacepileOutline) {
        let presenceArtwork_0;
        if (isRefinedGeometryEnabled) {
            const borderColor = usesSharedFacepileOutline ? "transparent" : colorMode === "light" ? "white" : "#1F1F21";
            const presenceTileFill = colorMode === "dark" && isWhiteBrand ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined;
            presenceArtwork_0 = {
                borderColor: borderColor,
                colorMode: colorMode,
                presenceTileFill: presenceTileFill,
                presenceOutline: presenceOutline
            };
        }
        const shellBorderColor = usesSharedFacepileOutline ? "transparent" : isRefinedGeometryEnabled ? colorMode === "dark" ? "transparent" : "var(--ds-surface, #FFFFFF)" : undefined;
        let t7;
        if ($[29] !== agent || $[30] !== shellBorderColor || $[31] !== showBorder) {
            t7 = showBorder && !agent.agentIcon ? $82c5dbca758f5691$var$getShellColors(agent, shellBorderColor) : undefined;
            $[29] = agent;
            $[30] = shellBorderColor;
            $[31] = showBorder;
            $[32] = t7;
        } else t7 = $[32];
        shellColors = t7;
        t6 = renderAgentAvatar(avatarSize_0, presenceArtwork_0);
        $[19] = agent;
        $[20] = avatarSize_0;
        $[21] = colorMode;
        $[22] = isWhiteBrand;
        $[23] = presenceOutline;
        $[24] = renderAgentAvatar;
        $[25] = showBorder;
        $[26] = usesSharedFacepileOutline;
        $[27] = shellColors;
        $[28] = t6;
    } else {
        shellColors = $[27];
        t6 = $[28];
    }
    const agentAvatar = t6;
    const t7 = showBorder && $82c5dbca758f5691$var$styles.root;
    const t8 = showBorder && $82c5dbca758f5691$var$styles[avatarSize_0];
    const t9 = isOverlapped && $82c5dbca758f5691$var$styles.overlapped;
    let t10;
    if ($[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
        t10 = (0, $w6R6I.cx)(t7, t8, t9);
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
        $[36] = t10;
    } else t10 = $[36];
    let t11;
    if ($[37] !== stackIndex) {
        t11 = {
            zIndex: stackIndex
        };
        $[37] = stackIndex;
        $[38] = t11;
    } else t11 = $[38];
    let t12;
    if ($[39] !== avatarSize_0 || $[40] !== colorMode || $[41] !== showBorder || $[42] !== usesSharedFacepileOutline) {
        t12 = showBorder && usesSharedFacepileOutline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk8Zi.AgentPresenceOutline), {
            color: colorMode === "light" ? "white" : "#1F1F21",
            size: avatarSize_0
        }) : null;
        $[39] = avatarSize_0;
        $[40] = colorMode;
        $[41] = showBorder;
        $[42] = usesSharedFacepileOutline;
        $[43] = t12;
    } else t12 = $[43];
    let t13;
    if ($[44] !== agentAvatar || $[45] !== avatarSize_0 || $[46] !== shellColors || $[47] !== showBorder || $[48] !== usesSharedFacepileOutline) {
        t13 = showBorder && shellColors ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82c5dbca758f5691$var$AgentAvatarShell, {
            ...shellColors,
            size: avatarSize_0
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.avatarContent
        }, agentAvatar)) : usesSharedFacepileOutline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.avatarContent
        }, agentAvatar) : agentAvatar;
        $[44] = agentAvatar;
        $[45] = avatarSize_0;
        $[46] = shellColors;
        $[47] = showBorder;
        $[48] = usesSharedFacepileOutline;
        $[49] = t13;
    } else t13 = $[49];
    let t14;
    if ($[50] !== t10 || $[51] !== t11 || $[52] !== t12 || $[53] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t10,
            style: t11,
            testId: "agent-presence-avatar"
        }, t12, t13);
        $[50] = t10;
        $[51] = t11;
        $[52] = t12;
        $[53] = t13;
        $[54] = t14;
    } else t14 = $[54];
    return t14;
}
module.exports["AgentPresenceAvatar"] = $82c5dbca758f5691$export$1233303c82069087;

});

parcelRegister("gedcG", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $951Av = parcelRequire("951Av");

const $1ad6c681998d2912$export$e657cd33d2484829 = '#DDDEE1';
const $1ad6c681998d2912$var$styles = {
    display: 'inline-flex',
    // Match the hexagonal shape used by AgentAvatar in Studio.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    clipPath: (0, $951Av.AGENT_AVATAR_CLIP_PATH),
    // Match the neutral background used by the unidentified external-agent avatar in Analytics.
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-unsafe-design-token-usage
    ['--ds-background-neutral']: $1ad6c681998d2912$export$e657cd33d2484829
};
const $1ad6c681998d2912$export$7d620265dc556e73 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { size: size } = t0;
    let t1;
    if ($[0] !== size) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "external-agent-avatar",
            style: $1ad6c681998d2912$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: size
        }));
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["EXTERNAL_AGENT_AVATAR_COLOR"] = $1ad6c681998d2912$export$e657cd33d2484829;
module.exports["ExternalAgentAvatar"] = $1ad6c681998d2912$export$7d620265dc556e73;

});

parcelRegister("951Av", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $gk8Zi = parcelRequire("gk8Zi");

const $c3120a5d48d2d743$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $c3120a5d48d2d743$var$AGENT_AVATAR_BORDER_WIDTH = 2;
const $c3120a5d48d2d743$var$AGENT_AVATAR_SIZE_PX = {
    small: 24,
    medium: 32
};
const $c3120a5d48d2d743$var$rootStyles = null;
const $c3120a5d48d2d743$var$borderStyles = null;
const $c3120a5d48d2d743$var$outlineContentStyles = null;
const $c3120a5d48d2d743$var$borderClipStyles = null;
const $c3120a5d48d2d743$var$badgeStyle = {
    backgroundColor: 'var(--agent-presence-badge-background)',
    bottom: '-2px',
    color: 'var(--agent-presence-badge-color)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 10,
    right: '-2px',
    userSelect: 'none',
    zIndex: 2
};
const $c3120a5d48d2d743$var$getBorderStyle = (size)=>{
    const borderedAvatarSize = $c3120a5d48d2d743$var$AGENT_AVATAR_SIZE_PX[size] + $c3120a5d48d2d743$var$AGENT_AVATAR_BORDER_WIDTH * 2;
    return {
        backgroundColor: `var(--agent-presence-border-color, ${"var(--ds-icon-inverse, #FFFFFF)"})`,
        height: borderedAvatarSize,
        width: borderedAvatarSize
    };
};
const $c3120a5d48d2d743$var$badgeStyles = null;
const $c3120a5d48d2d743$export$380c852bb5a56e77 = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { avatar: avatar, badgeLabel: badgeLabel, badgeTestId: t1, isOverlapped: isOverlapped, stackIndex: stackIndex, showBorder: showBorder, showPresenceBadge: showPresenceBadge, presenceOutlineColor: presenceOutlineColor, size: t2, testId: t3 } = t0;
    const badgeTestId = t1 === undefined ? "agent-presence-avatar-badge" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const testId = t3 === undefined ? "agent-presence-avatar" : t3;
    const t4 = isOverlapped ? "var(--ds-space-negative-075, -6px)" : undefined;
    let t5;
    if ($[0] !== stackIndex || $[1] !== t4) {
        t5 = {
            marginInlineStart: t4,
            zIndex: stackIndex
        };
        $[0] = stackIndex;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const rootStyle = t5;
    let t6;
    if ($[3] !== size) {
        t6 = $c3120a5d48d2d743$var$getBorderStyle(size);
        $[3] = size;
        $[4] = t6;
    } else t6 = $[4];
    const borderStyle = t6;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1mT5xdRAKS"
        ]);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== presenceOutlineColor || $[7] !== size) {
        t8 = presenceOutlineColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk8Zi.AgentPresenceOutline), {
            color: presenceOutlineColor,
            size: size
        }) : null;
        $[6] = presenceOutlineColor;
        $[7] = size;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== avatar || $[10] !== borderStyle || $[11] !== presenceOutlineColor || $[12] !== showBorder) {
        t9 = showBorder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_1uo2ZfTcEg"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: borderStyle,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT _37wbyuDIqT _42Yu6B7dHp"
            ])
        }, avatar)) : presenceOutlineColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_1mT5xdRAKS _42Yu6B7dHp"
            ])
        }, avatar) : avatar;
        $[9] = avatar;
        $[10] = borderStyle;
        $[11] = presenceOutlineColor;
        $[12] = showBorder;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== badgeLabel || $[15] !== badgeTestId || $[16] !== showPresenceBadge) {
        t10 = showPresenceBadge && badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: $c3120a5d48d2d743$var$badgeStyle,
            "data-testid": badgeTestId,
            className: (0, $hekY6.default)([
                "_0bjKvDKxmn _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VxpxF _39xV02xpxF _1kk5Tk7GSX"
            ])
        }, badgeLabel);
        $[14] = badgeLabel;
        $[15] = badgeTestId;
        $[16] = showPresenceBadge;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== rootStyle || $[19] !== t10 || $[20] !== t8 || $[21] !== t9 || $[22] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: rootStyle,
            "data-testid": testId,
            className: t7
        }, t8, t9, t10);
        $[18] = rootStyle;
        $[19] = t10;
        $[20] = t8;
        $[21] = t9;
        $[22] = testId;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $c3120a5d48d2d743$export$2f5dfaa7873e8973;
module.exports["AgentAvatarFrame"] = $c3120a5d48d2d743$export$380c852bb5a56e77;

});

parcelRegister("c6zRP", function(module, exports) {
const $49bfa46c557a50ec$export$64cd126c152ef69d = 30000;
const $49bfa46c557a50ec$export$f1e7f4004cc0d32 = $49bfa46c557a50ec$export$64cd126c152ef69d + 300000;
const $49bfa46c557a50ec$var$hasValidLastActive = (lastActive)=>typeof lastActive === 'number' && Number.isFinite(lastActive);
const $49bfa46c557a50ec$export$545448b69b42d8b = (agent, now = Date.now())=>{
    if (!$49bfa46c557a50ec$var$hasValidLastActive(agent.lastActive)) return 'active';
    const age = now - agent.lastActive;
    if (age >= $49bfa46c557a50ec$export$f1e7f4004cc0d32) return 'expired';
    if (age >= $49bfa46c557a50ec$export$64cd126c152ef69d) return 'inactive';
    return 'active';
};
const $49bfa46c557a50ec$export$70aa8e977829b349 = (lastActive, now = Date.now())=>{
    if (!$49bfa46c557a50ec$var$hasValidLastActive(lastActive)) return undefined;
    const inactiveAt = lastActive + $49bfa46c557a50ec$export$64cd126c152ef69d;
    if (inactiveAt > now) return inactiveAt;
    const expiresAt = lastActive + $49bfa46c557a50ec$export$f1e7f4004cc0d32;
    return expiresAt > now ? expiresAt : undefined;
};
const $49bfa46c557a50ec$export$f262baf6c8c08ca8 = (agent)=>$49bfa46c557a50ec$export$545448b69b42d8b(agent) !== 'active';
module.exports["getAgentPresenceStatus"] = $49bfa46c557a50ec$export$545448b69b42d8b;
module.exports["getNextAgentPresenceBoundary"] = $49bfa46c557a50ec$export$70aa8e977829b349;
module.exports["isAgentPresenceInactive"] = $49bfa46c557a50ec$export$f262baf6c8c08ca8;

});

parcelRegister("hlpSM", function(module, exports) {
const $1c7976239f2020c5$export$454786137388d58b = ({ id: id, actingUserId: actingUserId, includeActingUser: includeActingUser = false })=>includeActingUser && actingUserId ? `${id}:${actingUserId}` : id;
module.exports["getAgentPresenceKey"] = $1c7976239f2020c5$export$454786137388d58b;

});

parcelRegister("gk8Zi", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $71771e95bc58fd84$export$d825e67f4012c870 = {
    small: {
        width: 24,
        height: 27.75
    },
    medium: {
        width: 32,
        height: 35
    }
};
const $71771e95bc58fd84$export$505240e540ebe25 = {
    small: 'M 9.998 1.1574 A 4 4 0 0 1 14.002 1.1574 L 22.002 5.7824 A 4 4 0 0 1 24 9.2454 L 24 18.5046 A 4 4 0 0 1 22.002 21.9676 L 14.002 26.5926 A 4 4 0 0 1 9.998 26.5926 L 1.998 21.9676 A 4 4 0 0 1 0 18.5046 L 0 9.2454 A 4 4 0 0 1 1.998 5.7824 Z',
    medium: 'M 13.33 1.46 A 5 5 0 0 1 18.67 1.46 L 29.34 7.29 A 5 5 0 0 1 32 11.66 L 32 23.34 A 5 5 0 0 1 29.34 27.71 L 18.67 33.54 A 5 5 0 0 1 13.33 33.54 L 2.66 27.71 A 5 5 0 0 1 0 23.34 L 0 11.66 A 5 5 0 0 1 2.66 7.29 Z'
};
const $71771e95bc58fd84$var$OUTLINE_WIDTH = 2.5;
const $71771e95bc58fd84$var$styles = {
    root: "_1mT5xdWVPG _3OE6xY715P _1VJPcajssS _1pp6NdYbGa _42Yu6BdnbC"
};
const $71771e95bc58fd84$export$8b63d3e9f6d12780 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { color: color, size: size, testId: t1 } = t0;
    const testId = t1 === undefined ? "agent-presence-outline" : t1;
    const { width: width, height: height } = $71771e95bc58fd84$export$d825e67f4012c870[size];
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            top: "0.2px"
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $71771e95bc58fd84$var$styles.root
        ]);
        $[1] = t3;
    } else t3 = $[1];
    const t4 = `0 0 ${width} ${height}`;
    const t5 = $71771e95bc58fd84$export$505240e540ebe25[size];
    let t6;
    if ($[2] !== color || $[3] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: t5,
            fill: color,
            stroke: color,
            strokeWidth: $71771e95bc58fd84$var$OUTLINE_WIDTH * 2
        });
        $[2] = color;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== height || $[6] !== t4 || $[7] !== t6 || $[8] !== width) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            display: "block",
            width: width,
            height: height,
            viewBox: t4,
            overflow: "visible",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            focusable: "false"
        }, t6);
        $[5] = height;
        $[6] = t4;
        $[7] = t6;
        $[8] = width;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: t2,
            "data-testid": testId,
            "aria-hidden": "true",
            className: t3
        }, t7);
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
module.exports["AGENT_AVATAR_SHELL_SIZE"] = $71771e95bc58fd84$export$d825e67f4012c870;
module.exports["AGENT_AVATAR_SHELL_PATH"] = $71771e95bc58fd84$export$505240e540ebe25;
module.exports["AgentPresenceOutline"] = $71771e95bc58fd84$export$8b63d3e9f6d12780;

});


//# sourceMappingURL=AgentPresence.e92c6632.js.map
